export default "__VITE_ASSET__df947cb2__"